module.exports = __webpack_public_path__ + "6c906cc337c7faddbe21ab9e7b3e01a7.png";